module.exports = __webpack_public_path__ + "img/MeetingRoomOutlined.8b0bb4c8.svg";